import type { SupabaseClient } from '@supabase/supabase-js';
import { permissionModel } from '@/models/permissionModel';
import type { Database } from '@/types/supabase';

/**
 * Derive the caller's scorer permission scopes from their RLS client: the
 * federation ids they admin and the event ids they can score (event-admin,
 * referee-widened). The browser-bound `getUserPermissionsIncludingReferees`
 * helper can't run in a route handler, so the id sets are built directly from
 * `permissionModel`.
 *
 * Extracted from the scorable / scheduled-matches / from-schedule routes and
 * `scorerAccess`, which all derived these two sets identically.
 */
export async function deriveScorerScopes(
  supabase: SupabaseClient<Database>,
  userId: string,
): Promise<{ federationIds: string[]; eventIds: string[] }> {
  const [basePerms, eventAdminRolesWithReferees] = await Promise.all([
    permissionModel.getPermissions(supabase, userId),
    permissionModel.getEventAdminRolesIncludingReferees(supabase, userId),
  ]);
  return {
    federationIds: basePerms.federationAdminRoles.map((r) => r.federation_id),
    eventIds: eventAdminRolesWithReferees.map((r) => r.event_id),
  };
}
